<template>
    <div>
        <header-portrate />
        <exports-print ref="exportbar" />
        <div>
            <TabsComp :tabs="tabs" />
            <v-row class="mainrow mt-2 mb-2" :style="`margin-inline-start:2px;direction:`+lang.dir+`;margin-top:-8px !important;`">
                <v-row class="mt-5">
                    <v-col cols="12" md="12">
                        <form autocomplete="off">
                            <div class="searchTop">
                                <div class="searchBar">
                                    <div style="width:200px">
                                        <div class="mobileFont">{{lang.chose_from_list}} {{lang.start_date}}</div>
                                        <b-input-group>
                                            <b-form-select class="inborder text-center" style="width:33%;background:#efefef;" v-model="sd.day" :options="$store.state.daysList"/>
                                            <b-form-select class="inborder text-center" style="width:33%;background:#efefef;border-right:none !important;" v-model="sd.month" :options="$store.state.monthsList" />
                                            <b-form-select class="inborder text-center" style="width:34%;background:#efefef;" v-model="sd.year" :options="$store.state.yearList" />
                                        </b-input-group>
                                    </div>
                                    <div style="width:200px">
                                        <div class="mobileFont">{{lang.chose_from_list}} {{lang.end_date}}</div>
                                        <b-input-group>
                                            <b-form-select class="inborder text-center" style="width:33%;background:#efefef;" v-model="ed.day" :options="$store.state.daysList"/>
                                            <b-form-select class="inborder text-center" style="width:33%;background:#efefef;border-right:none !important;" v-model="ed.month" :options="$store.state.monthsList" />
                                            <b-form-select class="inborder text-center" style="width:34%;background:#efefef;" v-model="ed.year" :options="$store.state.yearList" />
                                        </b-input-group>
                                    </div>
                                    <div style="width:220px">
                                        <div class="mobileFont">{{lang.chose_from_list}} {{lang.worker}}</div>
                                        <b-form-select class="inborder text-center" style="width:100%;background:#efefef;" v-model="empid" :options="employeesList" />
                                    </div>
                                    <div>
                                        <div>&nbsp;</div>
                                        <b-button variant="light" style="padding-top:2px !important; padding-bottom:2px !important;background:blue;color:#fff;width:75px;" class="btnMobile"  :disabled="reportBusy" @click="getCurrentReport()">{{lang.search}}</b-button>
                                    </div>
                                </div>

                            </div>
                        </form>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" :style="`direction:${lang.dir};padding-inline-end:30px;`">
                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th :class="`backBlack text-center ${item.class}`" v-for="(item, index) in headers" :key="index" style="">{{ item.text }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in reportRow" :key="index">
                                    <td class="text-center">{{ item.counter }}</td>
                                    <td class="text-center">{{ item.cardid }}</td>
                                    <td class="text-center">{{ item.received_date }}</td>
                                    <td class="text-center">{{ item.work_type }}</td>
                                    <td class="text-center">{{ item.customer_name }}</td>
                                    <td class="text-center">{{ item.model }}</td>
                                    <td class="text-center">{{ item.plate_number }}</td>
                                    <td class="text-center">{{ item.received_date }}</td>
                                    <td class="text-center">{{ item.worker_name }}</td>
                                    <td class="text-center">{{ item.item_name }}</td>
                                    <td class="text-center">{{ item.accepect_time }}</td>
                                    <td class="text-center">{{ item.work_time }}</td>
                                    <td class="text-center">{{ item.sales_time }}</td>
                                    <td class="text-center">{{ item.price }}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>

                                    <th class="backBlack text-center" colspan="4">{{ lang.work_orders_count }}</th>
                                    <th class=" text-center">{{ counter }}</th>
                                    <th class="backBlack text-center" colspan="2">{{ lang.cars_count }}</th>
                                    <th class=" text-center">{{ plates_num }}</th>
                                    <th class="backBlack text-center"></th>
                                    <th class="backBlack text-center"></th>
                                    <th class="backBlack text-center"></th>
                                    <th class="backBlack text-center"></th>
                                    <th class="backBlack text-center">{{ lang.total }}</th>
                                    <th class=" text-center">{{ prices }}</th>
                                </tr>
                            </tfoot>
                        </v-simple-table>
                        <p class="mt-2">{{lang.work_report_totals_note}}</p>
                        <br>

                    </v-col>
                </v-row>
            </v-row>
        </div>
        <br><br>
        <Footer style="margin-top:20px;" />
    </div>
</template>

<script>
import HeaderPortrate from '@/components/Header-Portrate.vue'
import Footer from '@/components/Footer.vue'
import ExportsPrint from '@/components/exports-print.vue'
import TabsComp from '@/components/tabsComp.vue'
import axios from 'axios'
export default{
    components: {HeaderPortrate, Footer, ExportsPrint, TabsComp},
    data() {
        return {
            reportBusy:false, reportSerial:0,
            search: [],
            counter: 0,
            plates_num: 0,
            prices: 0,
            sd: {
                day: 1,
                month: (new Date()).getMonth() + 1,
                year: (new Date()).getFullYear(),
            },
            ed: {
                day: (new Date()).getDate(),
                month: (new Date()).getMonth() + 1,
                year: (new Date()).getFullYear(),
            },
            reportRow: [],
            employees: [],
            empid: 0,
            income_total: 0,
            expense_total: 0,
            cash_total: 0,
            other_total: 0,
            balance: 0,
        }
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        sdate: function(){
            let day = this.sd.day;
            let month = this.sd.month;
            if(this.sd.day <10) day = "0"+day;
            if(this.sd.month <10) month = "0"+month;
            return this.sd.year + '-' + month + '-' + day
        },
        edate: function(){
            let day = this.ed.day;
            let month = this.ed.month;
            if(this.ed.day <10) day = "0"+day;
            if(this.ed.month <10) month = "0"+month;
            return this.ed.year + '-' + month + '-' + day
        },
        tabs: function() {
          const menu = this.$store.getters['state'].menu;

            const license = this.$store.getters['state'].licenseType.activemenu;
            const alicense = this.$store.getters['state'].licenseType
            let currentMenu = menu[license];
            // console.log("menu",this.$store.getters['state'].licenseType)
            if(!license){
              return false;
            }
            let cMenu = {main: {},sub:[]};
            Object.values(currentMenu).forEach(value =>{
            const cM = localStorage.getItem('currentMenu');
            if(value.main.index == cM){
                cMenu = value.sub;
            }else if(cM == null && value.main.index == 1){
                cMenu = value.sub;
            }
            });

            let t = []
            Object.values(cMenu).forEach(value =>{

                if(this.$route.path == value.href){
                    value.class = "mytab";
                }else{
                    value.class = "mytab4";
                }
                if(this.lang.langname == 'ar'){
                    value.name = value.arname
                }else{
                    value.name = value.enname
                }
                for(let i =0; i< value.groupid.length;i++){
                    if(value.groupid[i] == this.$store.getters['state'].group_id){
                    if(alicense[value.perms[0]] || value.perms[0] == 'any')
                        t.push(value)
                    }
                }

            })

            return t;
      },
      employeesList: function(){
        let t = [{ text: this.lang.all, value: 0 }];
        for(let i = 0; i < this.employees.length; i++){
          const e = this.employees[i];
          t.push({
            text: (this.lang.langname == 'ar')
              ? (e.employee_name || e.full_name || e.name_ar || '')
              : (e.employee_name_en || e.employee_name || e.full_name || e.name_en || ''),
            value: e.id
          });
        }
        return t;
      },
      headers: function()
      {
        return [
            {
              text: "#",
              align: 'center',
              filterable: false,
              value: 'cardid',
              sortable: false,
              class: 'pa-0 backBlack'
            },
            {
                            text: this.lang.operation_number,
              align: 'center',
              filterable: false,
              value: 'cardid',
              sortable: false,
              class: 'pa-0 backBlack'
            },
            {
                            text: this.lang.date,
              align: 'center',
              filterable: false,
              value: 'cardid',
              sortable: false,
              class: 'pa-0 backBlack'
            },
            {
                            text: this.lang.invoice_type,
              align: 'center',
              filterable: false,
              value: 'cardid',
              sortable: false,
              class: 'pa-0 backBlack'
            },
            {
                            text: this.lang.customer,
              align: 'center',
              filterable: false,
              value: 'cardid',
              sortable: false,
              class: 'pa-0 backBlack'
            },
            {
                            text: this.lang.car,
              align: 'center',
              filterable: false,
              value: 'cardid',
              sortable: false,
              class: 'pa-0 backBlack'
            },
            {
                            text: this.lang.plate_number,
              align: 'center',
              filterable: false,
              value: 'cardid',
              sortable: false,
              class: 'pa-0 backBlack'
            },
            {
                            text: this.lang.operation_date,
              align: 'center',
              filterable: false,
              value: 'cardid',
              sortable: false,
              class: 'pa-0 backBlack'
            },
            {
                            text: this.lang.worker,
              align: 'center',
              filterable: false,
              value: 'cardid',
              sortable: false,
              class: 'pa-0 backBlack'
            },
            {
                            text: this.lang.service,
              align: 'center',
              filterable: false,
              value: 'cardid',
              sortable: false,
              class: 'pa-0 backBlack'
            },
            {
                            text: this.lang.expected_hours,
              align: 'center',
              filterable: false,
              value: 'cardid',
              sortable: false,
              class: 'pa-0 backBlack'
            },
            {
                            text: this.lang.operation_hours,
              align: 'center',
              filterable: false,
              value: 'cardid',
              sortable: false,
              class: 'pa-0 backBlack'
            },
            {
                            text: this.lang.sold_hours,
              align: 'center',
              filterable: false,
              value: 'cardid',
              sortable: false,
              class: 'pa-0 backBlack'
            },
            {
                            text: this.lang.sold_value,
              align: 'center',
              filterable: false,
              value: 'cardid',
              sortable: false,
              class: 'pa-0 backBlack'
            },
        ]
      }
    },
    methods: {
        collectSearch(id){
           return {
            module: 'worksReps',
                elements: {
                    sdate: this.sdate,
                    edate: this.edate,
                    empid: this.empid,
                },
            }

        },

        async getEmployees(){
            const post=new FormData();post.append('type','getWorkReportEmployees');post.append('defBranch',localStorage.getItem('defBranch'));post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));post.append('data[all]',1);
            try{const {data}=await axios.post(this.$store.state.SAMCOTEC.r_path,post);if(Number(data && data.error && data.error.number)!==200 || !Array.isArray(data.results && data.results.data1))throw new Error('invalid');this.employees=data.results.data1;}
            catch(error){this.employees=[];this.$snotify.error(this.lang.work_report_load_failed,this.lang.alert);}
        },
        async getCurrentReport(){
            const serial=++this.reportSerial,post=new FormData();post.append('type','getWorkReps');post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));post.append('defBranch',localStorage.getItem('defBranch'));post.append('lang',this.lang.langname);for(const [key,value] of Object.entries({sdate:this.sdate,edate:this.edate,empid:this.empid}))post.append('data['+key+']',value);this.reportBusy=true;
            try{const {data}=await axios.post(this.$store.state.SAMCOTEC.r_path,post);if(serial!==this.reportSerial)return false;if(Number(data && data.error && data.error.number)!==200 || !Array.isArray(data.results && data.results.data))throw new Error('invalid');Object.assign(this,{reportRow:data.results.data,counter:data.results.counter,plates_num:data.results.plates_num,prices:data.results.prices});return true;}
            catch(error){if(serial===this.reportSerial)this.$snotify.error(this.lang.work_report_load_failed,this.lang.alert);return false;}
            finally{if(serial===this.reportSerial)this.reportBusy=false;}
        }

    },
    created() {
        this.getEmployees();
        this.getCurrentReport();
    }
}
</script>